import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';

const BmmPrototypeRoute = lazy(() => import('./BmmPrototypeRoute'));

const applet = {
  id: 'bmm-prototype',
  path: '/bmm-prototype',
  paths: ['/bmm-prototype'],
  label: 'BMM Prototype',
  description: 'Constraint-based motion editing',
  dashboard: {
    title: 'BMM Prototype',
    description: 'Constraint-based motion editing.',
    order: 70,
  },
  policy: {
    requiresLoggedIn: true,
    requiresApiKey: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: BmmPrototypeRoute,
} satisfies AppletDefinition;

export default applet;
